import { reactive, ref, computed, watch, watchEffect } from '@vue/composition-api'
import store from '@/store'
import * as apiCommon from '@/api/common'

/**
 * QA一覧並び順設定ウィンドウ
 */
export const getGroup = (props, context) => {
  
  const group1 = reactive({
    
    // 並び順(作業用変数)
    list_order_work: '',

    // 並び順
    list_order: computed({
      get: () => {
        if (group1.list_order_work === '') {
          group1.list_order_work = store.state.qa.list_order
        }
        return group1.list_order_work
      },
      set: (order) => {
        group1.list_order_work = order
      }
    }),
    
    /**
     * 設定ボタン押下時
     */
    submit: () => {

      // ストアに保存
      store.dispatch('qa/setListOrderSettings', group1.list_order_work)

      // 詳細画面から一覧画面に戻ってきた時のスクロール位置指定用IDをクリア
      store.dispatch('qa/setSelectedListItemId', 0)

      // コールバック
      const callback = () => {
        // ページ番号を1ページに設定する
        store.dispatch('qa/setPage', 1)

        // 親画面の検索結果一覧を更新する
        context.parent.group1.updateSearchResultArea()

        // 本ウィンドウを閉じる
        context.emit('closeSearchOrderSettings')
      }
      // 表示設定、並び順設定を保存する
      store.dispatch('qa/saveListSettings', { callback: callback })
    },

    /**
     * 閉じる
     */
    close: () => {
      group1.list_order_work = ''
      context.emit('closeSearchOrderSettings')
    }

  })

  return group1
}
